import { RefObject } from "react";
import { Link } from "react-router-dom";
import { MdMenu, MdClose } from "react-icons/md";
import { ThemeSwitcher } from "../../../shared/components/ThemeSwitcher";
import { UiLanguageSwitcher } from "../../../shared/components/UiLanguageSwitcher";
import { TranslationKey } from "../../../shared/i18n/i18n";

type AdminShellHeaderProps = {
  currentUserName: string;
  currentUserSuperAdmin: boolean;
  isMobileNavOpen: boolean;
  isMobileViewport: boolean;
  isProfileMenuOpen: boolean;
  onSignOut: () => void;
  onToggleMobileNav: () => void;
  onToggleProfileMenu: () => void;
  profileMenuRef: RefObject<HTMLDivElement | null>;
  t: (key: TranslationKey) => string;
};

export const AdminShellHeader = ({
  currentUserName,
  currentUserSuperAdmin,
  isMobileNavOpen,
  isMobileViewport,
  isProfileMenuOpen,
  onSignOut,
  onToggleMobileNav,
  onToggleProfileMenu,
  profileMenuRef,
  t,
}: AdminShellHeaderProps) => {
  return (
    <header className="admin-shell-header">
      <div className="admin-shell-brand">
        {isMobileViewport ? (
          <button
            aria-controls="admin-mobile-nav"
            aria-expanded={isMobileNavOpen}
            aria-label={isMobileNavOpen ? t("admin.navlist.closeMobilePanel") : t("admin.navlist.openMobilePanel")}
            className="theme-switcher admin-mobile-nav-trigger"
            onClick={onToggleMobileNav}
            type="button"
          >
            {isMobileNavOpen ? <MdClose /> : <MdMenu />}
          </button>
        ) : null}
        <Link
          aria-label="Intelligo home"
          className="admin-shell-logo-link"
          to="/a/organizations"
        >
          <span
            aria-hidden="true"
            className="admin-heading-logo admin-shell-logo"
          />
        </Link>
      </div>
      <div className="admin-shell-actions">
        <UiLanguageSwitcher className="admin-shell-language-switcher" />
        <ThemeSwitcher className="admin-shell-theme-switcher" />
        <div
          className="admin-shell-profile"
          ref={profileMenuRef}
        >
          <button
            aria-expanded={isProfileMenuOpen}
            aria-haspopup="menu"
            className="theme-switcher admin-profile-trigger"
            onClick={onToggleProfileMenu}
            type="button"
          >
            <svg
              aria-hidden="true"
              fill="currentColor"
              height="20"
              viewBox="0 0 24 24"
              width="20"
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20" />
            </svg>
          </button>
          {isProfileMenuOpen ? (
            <div
              className="admin-profile-menu"
              role="menu"
            >
              <div className="admin-profile-menu-header">
                <div className="admin-profile-menu-user-name">{currentUserName}</div>
              </div>
              <Link
                className="admin-profile-menu-item"
                onClick={onToggleProfileMenu}
                role="menuitem"
                to="/a/profile/basic"
              >
                {t("admin.menu.profile")}
              </Link>
              {currentUserSuperAdmin ? (
                <Link
                  className="admin-profile-menu-item"
                  onClick={onToggleProfileMenu}
                  role="menuitem"
                  to="/a/administration/system-information"
                >
                  {t("admin.menu.administration")}
                </Link>
              ) : null}
              <button
                className="admin-profile-menu-item danger"
                onClick={onSignOut}
                role="menuitem"
                type="button"
              >
                {t("admin.signOut")}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
};
